import styled from 'styled-components'

// #region - selling/index
export const SellingPageContainer = styled.div`
    & > * {
        max-width: 1000px;
        margin-left: auto;
        margin-right: auto;
    }

    @media screen and (max-width: 1150px) {
        & > * {
            max-width: 800px;
        }
    }
    @media screen and (max-width: 850px) {
        & > * {
            max-width: 90%;
        }
    }

    & > *:not(& > *:last-child) {
        margin-bottom: 100px;
    }
`

export const Header = styled.div`
    background: url('/images/selling/header-bg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 517px;
    width: 100%;
    max-width: 100%;
    row-gap: 25px;
    padding: 10px 15px;
`

export const HeaderText = styled.p`
    font-size: 40px;
    text-align: center;
    color: #fff;
    font-family: "Jarkarta";
    @media (max-width: 600px) {
        font-size: 30px;
    }
`
export const HeaderDesc = styled.p`
    text-align: center;
    font-size: 24px;
    color: #fff;
    max-width: 750px;
    line-height: 1.5;
    font-family: "Jarkarta";
    @media (max-width: 600px) {
        font-size: 16px;
    }
`
export const CTAButton = styled.button`
    background: #fff;
    color: #125F3F;
    padding: 10px 0px;
    border-radius: 25px;
    width: 250px;
`

export const SectionDescription = styled.p`
    max-width: 630px;
    margin: auto;
    text-align: center;
    font-size: 20px;
    line-height: 1.5;
    font-family: "Jarkarta";

    @media (max-width: 600px) {
        font-size: 16px;
    }
`

export const SectionTitle = styled.p`
    margin: 25px auto;
    color: #000;
    width: fit-content;
    font-size: 30px;
    font-family: "Jarkarta";
    text-align: center;

    @media screen and (max-width: 600px) {
        font-size: 25px;
    }
`

export const TypeOfSellerSection = styled.div`
`
export const SellerTypeCardWrapper = styled.div`
    display: flex;
    flex-direction: row; 
    justify-content: center;
    align-items: stretch;
    gap: 30px;
    width: 100%;
    
    & > * {
        padding: 40px 45px;
    }
    @media (max-width: 765px) {
        flex-direction: column;
        & > * {
            padding: 15px 20px;
        }
    }
`

export const TipsForSellingSection = styled.div`
    @media (max-width: 850px) {
        width: 90%;
    }
    
`
export const Tips = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 70px;
    margin-top: 70px;

    @media (max-width: 850px) {
        grid-gap: 40px;
    }

    @media (max-width: 750px) {
        grid-template-columns: 1fr;
    }
`
export const TipContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 30px;

    @media (max-width: 750px) {
        row-gap: 15px;
    }
`
export const TipIcon = styled.div`
    background: #fff;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 1px solid #125F3F;
    display: flex;
    justify-content: center;
    align-items: center;

    & > * {
        width: 40px;
        height: 40px;
        color: #125F3F
    }

    @media (max-width: 850px) {
        width: 40px;
        height: 40px;
        & > * {
            width: 20px;
            height: 20px;
        }
    }
`
export const TipHeader = styled.div`
    font-weight: 500;
    font-size: 20px
`
export const TipDesc = styled.div`
    font-family: "Jarkarta";
`

export const FAQSection = styled.div`
    @media (max-width: 500px) {
        max-width: 100%;
        width: 100%;
    }
`

export const Footer = styled.div`
    height: 460px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 25px;
    max-width: 100%;
    margin-bottom: 100px;
    background: url('/images/selling/footer-bg.png');
    background-size: cover;
    background-repeat: no-repeat;    
    // background-position: center;
`
export const FooterText = styled.p`
    font-size: 40px;
    text-align: center;
    color: #fff;
    font-family: "Jarkarta";
    @media (max-width: 600px) {
        font-size: 30px;
    }
`

export const FAQHeaderText = styled.p`
    font-size: 20px;
    text-align: left;
    font-family: "Jarkarta";
    @media (max-width: 600px) {
        font-size: 18px;
    }
`
// #endregion
